class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.buyButton = this.querySelector("[name=add]");
    this.cart = document.querySelector("cart-popup");

    if (!this.cart) return;

    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
  }

  available() {
    this.setButton(false, window.i18n.products.product.add_to_cart);
    this.dispatchEvent(new CustomEvent("product:available"));
  }

  soldout() {
    this.setButton(true, window.i18n.products.product.sold_out);
    this.dispatchEvent(new CustomEvent('product:soldout'))
  }

  setProductVariant(option) {
    this.dataset.variantId = option.value;
    option.disabled ? this.soldout() : this.available();
  }
  
  addingToCart(text) {
    this.setButton(true, window.i18n.products.product.added_to_cart);
  }

  addedToCart() {
    this.setButton(true, window.i18n.products.product.added_to_cart);

    setTimeout(() => {
      this.setButton(false, window.i18n.products.product.add_to_cart);
    }, window.durations.veryLong);
  }

  setButton(disabled, text) {
    this.buyButton.disabled = disabled;
    if (text && text != this.buyButton.textContent) {
      this.buyButton.innerHTML = "";
      let textElement = document.createElement("span");
      textElement.innerHTML = text;
      this.buyButton.appendChild(textElement);
    }
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    this.addingToCart();

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, {
      ...fetchConfig("javascript"),
      body,
    })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cart.render(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.addedToCart();
      });
  }
}

customElements.define('product-form', ProductForm);
